import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';
import ModalContainer from './modalContainer';
import Icon from '../basic/icons';
interface ErrorMessageProps extends HTMLAttributes<HTMLDivElement> {
  visible: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<string>>;
  message: string;
  modal?: boolean;
}

const MessageLayout = ({ message }: { message: string }) => {
  return (
    <div data-testid="messageLayoutDiv" className="flex items-center">
      <div className="ml-2xs">
        <Icon name="warning" className="text-4xl sm:text-3xl text-alert-red" />
      </div>
      <div className="ml-2md">
        <p data-testid="message" className="text-left">
          {message}
        </p>
      </div>
    </div>
  );
};


const ErrorMessage = ({
  visible,
  setVisible,
  message,
  modal,
  className,
}: ErrorMessageProps): JSX.Element => {
  return (
    <>
      {modal ? (
        <ModalContainer visible={visible}>
          <Icon
            onClick={() => setVisible && setVisible('')}
            name="close"
            className="absolute top-sm right-sm cursor-pointer hover:text-secondary-200 text-xl"
          />
          <MessageLayout message={message} />
        </ModalContainer>
      ) : (
        visible && (
          <div
            data-testid="errorMessageDiv"
            className={clsx(className, 'border-2 border-natural-300 rounded p-md')}
          >
            <MessageLayout message={message} />
          </div>
        )
      )}
    </>
  );
};



export default ErrorMessage;
